import * as React from 'react';
import { Box, makeStyles, createStyles } from '@material-ui/core';

import cn from 'classnames';
import { TranquiTheme } from '../../containers/App/theme';

export interface SeparatorProps {
  className?: string;
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
}

const Separator: React.FC<SeparatorProps> = ({ className, spacing = 2 }) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (<Box className={cn(classes.root, className, `my-${spacing}`)} />);
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    borderBottom: `1px solid ${theme.palette.bg4.default}`,
  },
}));

export default Separator;
